"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "londa": {
    "d3d3fc8d": [{
      "hkey": "e1b5c9e9",
      "slug": "londa",
      "name": "Londa",
      "primary": true,
      "skipSearch": false
    }],
    "bucigna": [{
      "hkey": "e1b5c9e9",
      "slug": "londa",
      "name": "Londa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5981d021": [{
      "hkey": "78ee3350",
      "slug": "caiano",
      "name": "Caiano",
      "primary": true,
      "skipSearch": false
    }],
    "caiano-chiesa": [{
      "hkey": "78ee3350",
      "slug": "caiano",
      "name": "Caiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "eb3ceec7": [{
      "hkey": "e1b5c9e9",
      "slug": "londa",
      "name": "Londa",
      "primary": true,
      "skipSearch": false
    }],
    "croce-a-mori-valico": [{
      "hkey": "e1b5c9e9",
      "slug": "londa",
      "name": "Londa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a5e40d0e": [{
      "hkey": "e1b5c9e9",
      "slug": "londa",
      "name": "Londa",
      "primary": true,
      "skipSearch": false
    }],
    "petroio-chiesa": [{
      "hkey": "e1b5c9e9",
      "slug": "londa",
      "name": "Londa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "423e005a": [{
      "hkey": "e1b5c9e9",
      "slug": "londa",
      "name": "Londa",
      "primary": true,
      "skipSearch": false
    }],
    "vierle-chiesa": [{
      "hkey": "e1b5c9e9",
      "slug": "londa",
      "name": "Londa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;